import Cookies from 'js-cookie'

const TokenKey = 'token_manage'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}
export function setCookies (cookiesKey,value) {
  return Cookies.set(cookiesKey, value)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
